const styles = (theme) => ({
  icon: {
    width: 30,
    height: 30,
    marginTop: -2,
    marginRight: theme.spacing(1),
  },
  label: {
    display: 'inline-flex',
    alignItems: 'center',
  },
});

export default styles;
